import { styled } from 'styled-components'
import type { AbstractComponent } from 'react'

export const NotificationDiv: AbstractComponent<
	{|
		children?: React$Node,
	|},
	HTMLDivElement
> = styled.div.attrs({ className: 'font-game-headline' })`
	display: flex;
	align-items: center;
	justify-content: space-between;
	font-size: 2em;
	${({ theme }) => `
        font-weight: ${theme.fontBold};
        color:${theme.onBase};
        margin: ${theme.spacing2x} 0;
        padding: 0 ${theme.spacing}  0 ${theme.spacing5x} ;
    `}
	background-color:${({ theme }) => theme.base};
	height: 6em;
	width: 100%;
	border-bottom-right-radius: 3em;
	border-top-right-radius: 3em;
`

export const ImgWrapper: AbstractComponent<{|
	children: ?React$Node,
|}> = styled.div`
	margin-left: 5px;
	width: 24%;
	height: 80%;
	display: flex;
	justify-content: center;
	align-items: center;
	border-radius: 60px;
	${({ theme }) => `
    	background-color: ${theme.base3};
		padding: 10px;
		font-size: ${theme.fontxxs};
    `}
	svg {
		height: 100%;
	}
	img {
		display: flex;
		justify-content: center;
		height: 100%;
	}
`

export const NotificationSpan: AbstractComponent<{|
	children?: React$Node,
|}> = styled.span`
	width: 75%;
`
